import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const requiresAuth = (to, from, next) => {
  if(localStorage.getItem('token')) {
    next()
    return
  }

  next('/login')
}

const noRequiresAuth = (to, from, next) => {
  if(!localStorage.getItem('token')) {
    next()
    return
  }

  next('/home')
}

const HomePage = resolve => {
  require.ensure(['@/views/Home.vue'], () => {
    resolve(require('@/views/Home.vue'))
  })
}
const ConfigPage = resolve => {
  require.ensure(['@/views/config/Config.vue'], () => {
    resolve(require('@/views/config/Config.vue'))
  })
}

const DetailsPage = resolve => {
  require.ensure(['@/views/trips/Details.vue'], () => {
    resolve(require('@/views/trips/Details.vue'))
  })
}

const LoginPage = resolve => {
  require.ensure(['@/views/auth/Login.vue'], () => {
    resolve(require('@/views/auth/Login.vue'))
  })
}

const WorkingOnPage = resolve => {
  require.ensure(['@/views/working-on-page.vue'], () => {
    resolve(require('@/views/working-on-page.vue'))
  })
}

const NotFoundPage = resolve => {
  require.ensure(['@/views/404.page.vue'], () => {
    resolve(require('@/views/404.page.vue'))
  })
}

const routes = [
  {
    path: '/', redirect: '/home'
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/About.vue')
  },
  {
    path: '/home',
    name: 'Home',
    component: HomePage,
    beforeEnter: requiresAuth
  },
  {
    path: '/trip/details/:id',
    name: 'Trip Details',
    component: DetailsPage,
    beforeEnter: requiresAuth
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginPage,
    beforeEnter: noRequiresAuth
  },
  {
    path: '/configuration',
    name: 'Configuration',
    component: ConfigPage,
    beforeEnter: requiresAuth
  },
  {
    path: '/mailing-list',
    name: 'Mailing List',
    component: WorkingOnPage
  },
  {
    path: '*',
    name: '404',
    component: NotFoundPage
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
